<template>
  <MainLayout>
    <template #content>
      <div v-if="!IS_LOADING.status" class="content-container flex flex-col w-full px-8">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
          <form class="w-full flex flex-col" @submit.prevent="handleSubmit(onSubmit)">
            <div class="border-b border-gray-400 flex items-center justify-between pb-5">
              <span class="text-xl font-medium">Profil & Einstellungen</span>
              <button type="submit" class="company-bg-color px-5 py-3 rounded-md text-sm text-white">Speichern</button>
            </div>
            <div class="bg-white mt-8 p-6 w-full">
              <div class="border-b-2 flex flex-wrap mb-4 pb-4">
                <button
                  @click="currentTab = 0"
                  type="button"
                  class="px-4 py-3 rounded-md text-xs mr-4 mb-4"
                  :class="currentTab == 0 ? 'bg-black text-white' : 'border border-black text-black'"
                >
                  Profilinfo
                </button>
                <button
                  @click="currentTab = 1"
                  type="button"
                  class="px-4 py-3 rounded-md text-xs mr-4 mb-4"
                  :class="currentTab == 1 ? 'bg-black text-white' : 'border border-black text-black'"
                >
                  Passwort
                </button>
              </div>
              <div class="w-full" v-if="currentTab == 0">
                <div class="md:flex flex-row md:space-x-6 w-full">
                  <div class="w-full md:w-1/2">
                    <div>
                      <span class="block mb-1 text-sm">Logo</span>
                      <label
                        class="file flex flex-col input-field mb-3 px-3 py-3 rounded-sm text-2xs text-center cursor-pointer"
                        style="background-color: rgb(247, 247, 247)"
                      >
                        <ValidationProvider rules="" name="logo">
                          <i class="fa fa-cloud-upload-alt mb-2 mr-1 text-3xl text-center"></i>
                          (Ideales Maß ist 250px x 100px)
                          <input
                            type="file"
                            accept="'image/*'"
                            aria-label="File browser example"
                            @change="(e) => croppie(e, 'logo')"
                          />
                          <span class="file-custom"></span>
                        </ValidationProvider>
                      </label>
                      <section
                        v-if="logo && logo != '' && logo == form.company.logo"
                        class="relative border"
                        style="width: 250px; height: 100px"
                      >
                        <img :src="onSetLogo('set', logo)" style="width: auto; height: 100%" />
                      </section>
                      <section class="relative hidden">
                        <vue-croppie
                          ref="logo"
                          :enableOrientation="true"
                          :enableResize="false"
                          :boundary="{ width: 250, height: 100 }"
                          :viewport="{
                            width: 250,
                            height: 100,
                            type: 'square',
                          }"
                          @update="update('logo', 'logo')"
                        />
                      </section>
                    </div>

                    <div>
                      <span class="block mb-1 text-sm">Titelbild</span>
                      <label
                        class="file flex flex-col input-field mb-3 px-3 py-3 rounded-sm text-2xs text-center cursor-pointer"
                        style="background-color: rgb(247, 247, 247)"
                      >
                        <i class="fa fa-cloud-upload-alt mb-2 mr-1 text-3xl text-center"></i>
                        (Ideales Maß ist 1920px x 1080px)
                        <ValidationProvider rules="" name="header_logo">
                          <input
                            type="file"
                            accept="'image/*'"
                            aria-label="File browser example"
                            @change="(e) => croppie(e, 'header_logo')"
                          />
                        </ValidationProvider>
                        <span class="file-custom"></span>
                      </label>
                      <section
                        v-if="header_logo && header_logo != '' && header_logo == form.company.header_logo"
                        class="relative border"
                        style="width: 250px; height: 141px"
                      >
                        <img :src="onSetLogo('set', header_logo)" style="width: auto; height: 100%" />
                      </section>
                      <section class="relative hidden">
                        <vue-croppie
                          ref="header_logo"
                          :enableOrientation="true"
                          :enableResize="false"
                          :boundary="{ width: 384, height: 216 }"
                          :viewport="{
                            width: 384,
                            height: 216,
                            type: 'square',
                          }"
                          @update="update('header_logo', 'header_logo')"
                        />
                      </section>
                    </div>

                    <InputField
                      v-if="AUTH_USER.role.name == 'seller'"
                      id="company_name"
                      class="mb-4 mt-4"
                      v-model="form.company.name"
                      type="text"
                      rules="required"
                      :errorMessages="errorMessages.company && errorMessages.company.name"
                    >
                      <template #label_>
                        <div class="flex flex-row">
                          <Header5 label="Unternehmensname" />
                          <div class="tooltip ml-1">
                            <i
                              v-tippy
                              class="fas fa-info-circle text-base text-gray-700"
                              content="Teile uns hier deinen Firmennamen mit. Dieser Name wird auch auf der Rechnung bei einem Gutscheinverkauf angeführt."
                            />
                          </div>
                        </div>
                      </template>
                    </InputField>

                    <InputField
                      id="username"
                      class="mb-4"
                      v-model="form.username"
                      type="text"
                      :rules="`required`"
                      :errorMessages="errorMessages.username"
                      :disabled="form.id ? true : false"
                    >
                      <template #label_>
                        <div class="flex flex-row">
                          <Header5 v-if="AUTH_USER.role.name == 'seller'" label="Name auf Gutschein" />
                          <Header5 v-if="AUTH_USER.role.name == 'user'" label="Benutzername" />
                          <div v-if="AUTH_USER.role.name == 'seller'" class="tooltip ml-1">
                            <i
                              v-tippy
                              class="fas fa-info-circle text-base text-gray-700"
                              content="Wähle einen Wunschnamen als Benutzername. Der Benutzername ist auf dem Gutschein ersichtlich und kann im Nachhinein nicht mehr geändert werden."
                            />
                          </div>
                        </div>
                      </template>
                    </InputField>

                    <TextAreaField
                      id="text"
                      v-model="form.company.description"
                      class="my-2"
                      label="Beschreibung deines Unternehmens"
                      rules="max:800"
                      :errorMessages="errorMessages.description"
                    />
                    <InputField
                      id="company_web_site"
                      v-model="form.company.url"
                      type="text"
                      class="my-2"
                      label="Webseite"
                      rules=""
                      :errorMessages="errorMessages.url"
                    />

                    <InputField
                      id="vat_number"
                      v-model="form.company.vat_number"
                      type="text"
                      class="my-2"
                      label="UID Nummer"
                      :errorMessages="errorMessages.vat_number"
                    />
                  </div>
                  <div class="w-full md:w-1/2">
                    <SelectField
                      id="month"
                      v-model="form.company.region_id"
                      :options="REGIONS"
                      class="my-2"
                      label="Region"
                      rules="required"
                      :errorMessages="errorMessages.region_id"
                    />

                    <div class="flex flex-col sm:flex-row">
                      <InputField
                        id="city"
                        v-model="form.city"
                        type="text"
                        class="w-full sm:w-1/2 sm:mr-2 mb-4"
                        label="Stadt"
                        :errorMessages="errorMessages.city"
                      />
                      <InputField
                        id="zip_code"
                        v-model="form.zip_code"
                        type="text"
                        class="w-full sm:w-1/2 sm:ml-2 mb-4"
                        label="Postleitzahl"
                        :errorMessages="errorMessages.zip_code"
                      />
                    </div>
                    <InputField
                      v-if="AUTH_USER.role.name == 'seller'"
                      id="address"
                      class="mb-4"
                      v-model="form.address"
                      type="text"
                      label="Hausnummer"
                      :errorMessages="errorMessages.address"
                    />
                    <InputField
                      id="email"
                      class="mb-4"
                      v-model="form.email"
                      type="text"
                      label="Emailadresse "
                      :rules="`required|email`"
                      :errorMessages="errorMessages.email"
                    />
                    <InputField
                      v-if="AUTH_USER.role.name == 'seller'"
                      id="phoneNumber"
                      v-model="form.phone_number"
                      type="number"
                      class="w-full mb-4"
                      label="Telefonnummer"
                      :errorMessages="errorMessages.phone_number"
                      rules="required"
                    />
                    <InputField
                      v-if="AUTH_USER.role.name == 'seller'"
                      id="orderEmails"
                      v-model="form.order_email"
                      type="email"
                      class="w-full mb-4"
                      label="Zusätzliche Emailadresse"
                      :errorMessages="errorMessages.order_email"
                    />
                  </div>
                </div>
              </div>
              <div v-if="AUTH_USER.role.name == 'seller' && currentTab == 1" class="w-full mt-5 md:flex">
                <ValidationObserver v-slot="{ handleSubmit }" class="w-full md:w-1/2">
                  <form class="flex flex-col w-full" @submit.prevent="handleSubmit(onSubmit)">
                    <div class="flex flex-col w-full">
                      <InputField
                        id="current_password"
                        v-model="form.current_password"
                        type="password"
                        class="my-2"
                        label="Passwort bestätigen"
                        rules="required|min:8|max:16"
                        :errorMessages="errorMessages.current_password"
                      />
                      <InputField
                        id="new_password"
                        v-model="form.new_password"
                        type="password"
                        class="my-2"
                        label="Neues Passwort"
                        rules="required|min:8|max:16"
                        :errorMessages="errorMessages.new_password"
                      />
                      <InputField
                        id="repeat_password"
                        v-model="form.repeat_password"
                        type="password"
                        class="my-2"
                        label="Passwort wiederholen"
                        rules="required|min:8|max:16|password:@new_password"
                        :errorMessages="errorMessages.repeat_password"
                      />
                    </div>
                    <div class="mt-8 flex">
                      <Button type="submit" label="Speichern" size="w-full py-3 px-4 " round="rounded" />
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import MainLayout from "_layouts";
import Button from "_components/Button";
import ProfileForm from "_components/Modules/Profile/Form/ProfileForm";
import CompanyForm from "_components/Modules/Profile/Form/CompanyForm";
import Header2 from "_components/Headers/Header2";
import InputField from "_components/Form/InputField";
import Header5 from "_components/Headers/Header5";

import SelectField from "_components/Form/SelectField";
import TextAreaField from "_components/Form/TextAreaField";

export default {
  name: "Profile",
  components: {
    MainLayout,
    ProfileForm,
    CompanyForm,
    InputField,
    Button,
    Header2,
    Header5,

    SelectField,
    TextAreaField,
  },
  data() {
    return {
      isRouteChanged: false,
      isSubmitted: false,
      errorMessages: [],
      logo: "",
      header_logo: "",
      logoUpdate: false,
      currentTab: 0,
      form: {
        id: null,
        current_password: "",
        new_password: "",
        repeat_password: "",
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        address: "",
        city: "",
        zip_code: "",
        phone_number: "",
        company: {
          name: "",
          description: "",
          url: "",
          logo: "",
          header_logo: "",
          region: "",
          vat_number: "",
        },
        order_email: "",
      },
    };
  },
  computed: {
    AUTH_USER() {
      return this.$store.getters.AUTH_USER;
    },
    REGIONS() {
      return this.$store.getters.REGIONS;
    },
    IS_LOADING() {
      return this.$store.getters.IS_LOADING;
    },
    isFormDirty() {
      return Object.keys(this.$refs.observer.fields).some((key) => this.$refs.observer.fields[key].dirty);
    },
  },
  watch: {},
  mounted() {
    (async () => {
      this.currentTab = this.$route.query.currentTab || 0;
      try {
        await this.$store.commit("SET_IS_LOADING", { status: "open" });
        await this.onFetchUser();
        if (this.AUTH_USER.role.name == "seller") {
        }
        await this.$store.commit("SET_IS_LOADING", { status: "close" });
      } catch (err) {
        await this.$store.commit("SET_IS_LOADING", { status: "close" });
      }
    })();
  },
  methods: {
    async onSubmit() {
      try {
        this.errorMessages = [];
        await this.$store.commit("SET_IS_PROCESSING", { status: "open" });
        if (this.AUTH_USER.role.name == "seller") {
          if (this.form?.company?.region_id) {
            this.form.company.region = this.form.company.region_id.label;
            delete this.form.company.region_id;
          }

          this.form.company.logo = this.logo;
          this.form.company.header_logo = this.header_logo;
        }

        this.form.id = this.AUTH_USER.data.id;

        const data = await this.$store.dispatch("UPDATE_USER", this.form);
        await this.$store.commit("SET_IS_PROCESSING", { status: "close" });
        this.$swal({
          icon: "success",
          title: "Erfolgreich!",
          text: "Info aktualisiert.",
          allowOutsideClick: false,
          showConfirmButton: false,
          confirmButtonColor: "#48BB78",
          timer: 1000,
          timerProgressBar: true,
        }).then((result) => {
          if (!this.isRouteChanged) {
            this.isSubmitted = true;
            this.$router.push("/home");
          }
        });
      } catch (err) {
        console.log(err.response);

        if (err?.response?.status == 500 && err?.response?.data?.message.indexOf("account is verified") != -1) {
          this.$swal({
            icon: "warning",
            title: "Achtung!",
            text: "You cannot change verification file if an account is verified",
            confirmButtonColor: "#48BB78",
          });
        }

        if (err?.response?.status == 422) {
          this.errorMessages = err.response.data.errors;
        }
        await this.$store.commit("SET_IS_PROCESSING", { status: "close" });
      }
    },
    onChange(data) {
      this.form = {
        ...this.form,
        ...data,
      };
    },
    async onFetchUser() {
      try {
        const { user } = await this.$store.dispatch("FETCH_USER", {
          id: this.AUTH_USER.data.id,
        });

        let params = {
          id: user.id,
          username: user.username,
          firstName: user.detail.firstName,
          lastName: user.detail.lastName,
          email: user.email,
          address: user.detail.address,
          city: user.detail.city,
          zip_code: user.detail.zip_code,
          phone_number: user.detail.phone_number,
          bday: user.bday,
          company: null,
          order_email: user.order_email,
        };

        if (this.AUTH_USER.role.name == "seller") {
          const region = this.REGIONS.filter((row) => user.company.region == row.label);
          params = {
            ...params,
            company: {
              name: user.company.name,
              description: user.company.description,
              url: user.company.url,
              logo: user.company.logo,
              header_logo: user.company.header_logo,
              region: user.company.region,
              region_id: region ? region[0] : "",
              vat_number: user.company.vat_number,
            },
          };
        }
        this.logo = user.company.logo;
        this.header_logo = user.company.header_logo;
        this.form = params;
      } catch (err) {
        console.log("err", err);
      }
    },
    onSetLogo(action, value) {
      if (action == "set") {
        return value.search("base64") < 0 ? `${process.env.VUE_APP_API_BASE_URL}/storage/${value}` : value;
      } else {
        this.form.company.logo = "";
        this.logo = "";
      }
    },
    croppie(e, ref) {
      this.$refs.observer.fields[ref].dirty = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs[ref].$vnode.elm.parentElement.classList.remove("hidden");
        this.$refs[ref].bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
    },
    // CALBACK USAGE
    crop(ref, form) {
      // Here we are getting the result via callback function
      // and set the result to this.cropped which is being
      // used to display the result above.
      let size = { width: 250, height: 100 };

      if (form == "header_logo") {
        size = { width: 1920, height: 1080 };
      }

      let options = {
        type: "base64",
        format: "jpeg",
        size,
        quality: 1,
      };
      this.$refs[ref].result(options, (output) => {
        this[form] = output;
      });
    },
    update(ref, form) {
      this.crop(ref, form);
    },
    removeImage(e, form) {
      e.target.parentElement.classList.add("hidden");
      this.form[form] = "";
      this.form[form + "_update"] = false;
    },
  },
};
</script>
<style lang="css" scoped>
.company-logo {
  width: 250px;
  height: 100px;
  border: 1px solid #ccc;
}
input[type="file"] {
  display: none;
}
</style>
